interface ShortCodeTagProps {
  code: string;
  className?: string;
  variant?: 'indigo' | 'brand' | 'emerald' | 'amber';
  showIcon?: boolean;
}

export function ShortCodeTag({ code, className, variant = 'indigo', showIcon = true }: ShortCodeTagProps) {
  const variantClasses = {
    indigo: 'bg-indigo-50 text-indigo-700 border-indigo-200/80',
    brand: 'bg-brand-50 text-brand-700 border-brand-200/80',
    emerald: 'bg-emerald-50 text-emerald-700 border-emerald-200/80',
    amber: 'bg-amber-50 text-amber-700 border-amber-200/80',
  };

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-mono font-bold uppercase tracking-wide border shadow-2xs ${variantClasses[variant]} ${className || ''}`}
    >
      {showIcon && (
        <svg className="w-3 h-3 opacity-75 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 21h18M5 21V5a2 2 0 012-2h10a2 2 0 012 2v16M9 9h6M9 13h6M9 17h6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )}
      <span>{code}</span>
    </span>
  );
}
